<td>{{name}}</td>
<td class="tools">
    <a href="/apps/{{appId}}/alert-zones/{{id}}" title="{{t "common.edit"}}" class="edit"><i class="icon-pencil"></i></a>
    <i class="icon-trash delete" title="{{t "mediaLibrary.delete"}}"></i>
</td>
